import React from "react";
import BFLoginBackground from "../../icons/BF2025/BFLoginBackground.svg";
import YellowArrowRight from "../../icons/BF2025/YellowArrowRight.svg";
import { BLACK_FRIDAY_SHOP_URL } from "../../config/blackFridayConfig";
import * as styles from "./BFLoginAside.module.scss";

/**
 * Black Friday promotional block component.
 * Displays a clickable promotional image that links to the shop.
 * Meant to be appended below the standard login/signup aside content.
 *
 * @returns {ReactElement} The Black Friday promotional block.
 */
function BFLoginAside() {
	return (
		<div className={ styles.promoContainer }>
			<a
				href={ BLACK_FRIDAY_SHOP_URL }
				className={ styles.promoLink }
				style={ { backgroundImage: `url(${ BFLoginBackground })` } }
				target="_blank"
				rel="noopener noreferrer"
			>
				30% OFF for BLACK FRIDAY
				<span>Upgrade now<img src={ YellowArrowRight } alt="" /></span>
			</a>
		</div>
	);
}

export default BFLoginAside;
